import { render, staticRenderFns } from "./empty.vue?vue&type=template&id=2681fc93"
import script from "./empty.vue?vue&type=script&lang=ts"
export * from "./empty.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {AppScrollToTop: require('/app/components/AppScrollToTop.vue').default,AppSnackBarMessages: require('/app/components/AppSnackBarMessages.vue').default})
